import { render, staticRenderFns } from "./UpcomingGames.vue?vue&type=template&id=7dacc2b0&scoped=true"
import script from "./UpcomingGames.vue?vue&type=script&lang=js"
export * from "./UpcomingGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dacc2b0",
  null
  
)

export default component.exports